import "./PestControl.module.css";
import Header from "@/reusable_sections/Header";
import Overview from "./sections/Overview";
import Pests from "./sections/Pests";
import Locality from "./sections/Locality";
import Faqs from "./sections/Faqs";
import Cta from "./sections/Cta";
import Footer from "@/reusable_sections/Footer";
export default function PestControlPage() {
  return <div>
      <Header />
      <Overview />
      <Pests />
      <Locality />
      <Faqs />
      <Cta />
      <Footer />
    </div>;
}